"use strict";
//
//
//
//
//
//
//
//
'kiwi public';

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;
var _default = {
  props: ['user', 'buffer'],
  computed: {
    status: function status() {
      if (!this.user || !this.buffer) {
        return '';
      }

      return this.user.typingStatus(this.buffer.name).status;
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["TypingStatusIndicator"]
window._kiwi_exports.components.TypingStatusIndicator = exports.default ? exports.default : exports;
